// @flow

import enGB from "./en_GB.json"
import type { Locale } from "../types/IntlTypes"

const locale: Locale = {
  messages: enGB,
  name: "en",
}

export default locale
